import type { ReactNode } from "react";

export function PageShell({
  children,
  className = "",
  narrow = false,
}: {
  children: ReactNode;
  className?: string;
  narrow?: boolean;
}) {
  return (
    <main
      className={`mx-auto w-full px-5 py-8 sm:px-7 sm:py-10 animate-screen-in ${
        narrow ? "max-w-[760px]" : "max-w-[1080px]"
      } ${className}`}
    >
      {children}
    </main>
  );
}
